<div class="clsWrapper {{ theme }}">
  @if (visible) {
    <div class="chat-box" [@fadeInOut]="visible">
      <div class="chat-box-body">
        <div class="chat-box-header">
          <div class="">
            <div class="operator-status d-none">
              {{ operator.status }}
              <span class="operator-status-online">●</span>
              <button class="chat-button-header" (click)="toggleChat()">✕</button>
            </div>
            <app-chat-avatar class="main-avatar" [image]="operator.avatar"></app-chat-avatar>
            <h3 class="operator-name d-none">
              {{ operator.name }}
            </h3>
          </div>
        </div>
        <div class="chat-box-main">
          <div class="chat-message-bottom" #bottom></div>
          @for (message of messages; track message) {
            <div
              class="chat-message m-2 mb-4"
              [class.chat-message-received]="message.type === 'received'"
              [@fadeIn]
              [class.chat-message-sent]="message.type === 'sent'">
              <div>
                <app-chat-avatar [image]="message.from.avatar" class="chat-message-from-avatar"></app-chat-avatar>
                <div class="chat-message-text">
                  {{ showMessage(message) ? message?.text?.msg : message?.text }}
                  @if (showTable(message, 'table')) {
                    <table class="table table-bordered" aria-describedby="showTable">
                      <thead>
                        <tr>
                          @for (head of getHeaderName(message) | keys; track head) {
                            <th class="px-1 py-1">
                              {{ head }}
                            </th>
                          }
                        </tr>
                      </thead>
                      <tbody>
                        @for (item of getColumnData(message).slice(0, 4); track item) {
                          <tr>
                            @for (list of item | keys; track list) {
                              <td class="px-1 py-1">
                                {{ item[list] }}
                              </td>
                            }
                          </tr>
                        }
                      </tbody>
                    </table>
                  }
                  @if (showTable(message, 'table')) {
                    <div>
                      <a href="javascript:void(0)" (click)="getChatBotInfo(message)" title="View more">View more</a>.
                    </div>
                  }
                  @if (showTable(message, 'link')) {
                    <div>
                      <button type="button" class="btn btn-primary btn-sm" (click)="downloadFile(message)">
                        <em class="pi pi-download me-1" title="Download"></em>Download</button
                      >.
                    </div>
                  }
                  @if (showTable(message, 'questions')) {
                    <ul class="list-group questions mt-2">
                      @for (item of getColumnData(message); track item) {
                        <li
                          class="list-group-item p-2 mb-1 border border-primary"
                          role="button"
                          (click)="raiseQuestions(item)">
                          {{ item }}
                        </li>
                      }
                    </ul>
                  }
                </div>
              </div>
              <div class="chat-message-date">
                {{ message.date | date: 'short' }}
                @if (message.type === 'received' && message.question) {
                  <span style="bottom: -6px">
                    <span class="thumbs">
                      <span
                        title="Like"
                        ngClass="{{ getLikeStatus(message) ? 'thumbs-up active' : 'thumbs-up' }}"
                        (click)="activeLike(message)"></span>
                      <span
                        title="Dislike"
                        ngClass="{{ getDisLikeStatus(message) ? 'thumbs-down active' : 'thumbs-down' }}"
                        (click)="activeDisLike(message)"></span>
                    </span>
                  </span>
                }
              </div>
              @if (openFeedback && selectedmessage === message) {
                <div class="comment mt-n1 mb-3">
                  <p>Enter your feedback here</p>
                  <div class="feedback-bottom">
                    <input
                      placeholder="Type here to share your feedback"
                      id="comment-input"
                      type="text"
                      maxlength="1000" />
                    <div class="feedback-send" (click)="sendFeedback(message)">Send</div>
                  </div>
                  <span class="close-comment">
                    <em
                      class="pi pi-times close-btn"
                      title="close"
                      style="width: 10px; height: 10px; vertical-align: top; font-size: 12px"
                      (click)="closeFeedback()"></em>
                  </span>
                </div>
              }
            </div>
            @if (spin) {
              <div class="typing">
                <div class="bubble">
                  <div class="ellipsis one"></div>
                  <div class="ellipsis two"></div>
                  <div class="ellipsis three"></div>
                </div>
              </div>
            }
          }
        </div>
        <div class="chat-box-footer">
          <app-chat-input
            (send)="sendMessage($event)"
            (dismiss)="toggleChat()"
            (focus)="(focus)"
            [clearSearch]="clearSearch"></app-chat-input>
        </div>
        @if (menuList.length > 0) {
          <div class="autosuggest">
            <div class="close-btn d-flex align-items-center justify-content-end mx-2 my-2">
              <a href="javascript:void(0)" class="auto-suggestions-close text-right" (click)="toggleShow()">
                <em class="pi pi-times close-btn" title="close"></em>
              </a>
            </div>
            <ul class="mb-0 mx-2">
              @for (item of menuList; track item) {
                <li (click)="selectMessage(item)">
                  {{ item }}
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </div>
  }

  <button type="button" class="chat-button" (click)="toggleChat()" title="Chatbot">
    @if (visible) {
      <span [@fadeIn]>
        <em class="fa fa-times"></em>
      </span>
    }
    @if (!visible) {
      <span [@fadeIn]>
        <img src="../../../../../assets/images/chat.png" width="20" alt="chat-icon" />
      </span>
    }
  </button>
</div>
